<template>
  <v-card
    class="details pa-2"
  >
    <v-container
      style="background-color: #fff;"
    >
      <v-btn
        absolute
        icon
        dark
        small
        class="close-btn"
        round
        @click="$emit('close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-layout wrap>
        <v-flex
          xs4
        >
          <v-text-field
            label="顧客番号"
            color="metalBlue"
            readonly
            :value="code"
          />
        </v-flex>
        <v-flex
          xs8
        >
          <v-text-field
            label="名称"
            color="metalBlue"
            readonly
            :value="name"
          />
        </v-flex>
        <v-flex
          xs12
        >
          <v-text-field
            label="電話番号"
            color="metalBlue"
            readonly
            :value="tel"
          />
        </v-flex>
        <v-flex
          xs12
        >
          <v-text-field
            label="住所"
            color="metalBlue"
            readonly
            :value="address"
          />
        </v-flex>
        <v-flex d-flex>
          <v-flex
            xs8
          >
            <v-textarea
              :value="remarks"
              rows="3"
              no-resize
              label="備考"
              color="metalBlue"
              readonly
            />
          </v-flex>
          <v-flex
            xs4
            d-flex
            class="refuel-btn-container"
          >
            <RefuelButton
              v-if="config.useManualSupplyRegistration"
              :id="id"
              :code="code"
            />
          </v-flex>
        </v-flex>

        <v-flex
          xs12
          style="position: relative;"
        >
          <span class="tank-info">
            タンク情報
          </span>
          <v-flex
            xs12
            py-0
          >
            <v-btn
              class="ma-0 mt-3 pa-0"
              :disabled="!tankIndex"
              flat
              block
              @click="tankIndex--"
            >
              <v-icon size="26">
                mdi-menu-up
              </v-icon>
            </v-btn>
            <span class="pagination">{{ paginationText }}</span>
          </v-flex>
          <div class="tank-box">
            <v-layout
              v-for="tank in tanks.slice(tankIndex, tankIndex + 3)"
              :key="tank.id"
              style="cursor:pointer"
              :class="tank.id === tankItem.id ? 'active' : ''"
              align-center
              pt-1
              px-1
              @click.stop="selectTank($event, tank)"
            >
              <v-flex xs2>
                <v-icon
                  :color="sensorState2Color[tank.sensorState]"
                >
                  mdi-flash-circle
                </v-icon>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  :value="tank.legalMax"
                  color="metalBlue"
                  label="タンク容量"
                  style="pointer-events:none"
                  readonly
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  :value="tank.rest"
                  label="残量"
                  color="metalBlue"
                  style="pointer-events:none"
                  readonly
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  :value="tank.volumeThreshold"
                  label="しきい値"
                  style="pointer-events:none"
                  color="metalBlue"
                  readonly
                />
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  :value="tank.margin.label"
                  color="metalBlue"
                  label="補給猶予"
                  style="pointer-events:none"
                  readonly
                />
              </v-flex>
            </v-layout>
          </div>
          <v-flex
            xs12
            py-0
          >
            <v-btn
              class="ma-0 pa-0"
              :disabled="tanks.length <= tankIndex + 3"
              flat
              block
              @click="tankIndex++"
            >
              <v-icon size="26">
                mdi-menu-down
              </v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <transition name="chart">
      <DeliveryTankChart
        v-if="(tankItem.id || tankChartLoader) && selected"
        :customer="selected"
        :tank="tankItem"
        :records="records"
        :tank-chart-loader="tankChartLoader"
      />
    </transition>
  </v-card>
</template>

<script>
import { api } from '@/api.js'
import { mapState } from 'vuex'
import { DeliveryTankChart } from './DeliveryDetail/index'

const props = ['id', 'code', 'name', 'address', 'tel', 'remarks', 'tanks']

export default {
  components: {
    DeliveryTankChart,
    RefuelButton: () => import('@/components/input/RefuelButton')
  },
  props: {
    selected: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // Tank info
      id: null,
      code: '',
      name: '',
      address: '',
      tel: '',
      remarks: '',
      tanks: [],
      /// ///
      tankIndex: 0,
      tankChartLoader: false,
      tankItem: {},
      records: []
    }
  },
  computed: {
    ...mapState('app', ['config']),
    ...mapState('list', ['sensorState2Color']),
    paginationText () {
      const length = this.tanks.length
      const tankIndex = this.tankIndex + 1
      const ceil = Math.min(tankIndex + 2, length)
      return `(${tankIndex} - ${ceil}) / ${length}`
    }
  },
  watch: {
    selected (value, old) {
      value = value || { tanks: [] }
      props.forEach(prop => { this[prop] = value[prop] })
      this.tankIndex = 0

      // show the tankChart when selecting new customer row everytime
      this.showTank(value.tanks[0] || {})
    }
  },
  methods: {
    selectTank ({ currentTarget }, tank) {
      if (currentTarget.classList.contains('active')) this.tankItem = {}
      else this.showTank(tank)
    },
    async showTank (tankParam) {
      if (!tankParam.id) {
        this.tankItem = {}
        return
      }

      // to add the active class to the tank row, instantly when the tank row selected
      this.tankItem = tankParam

      this.tankChartLoader = true
      try {
        const { record, sensor, tank } = await api.getCustomerTank(this.selected.id, tankParam.id)
        if (sensor) {
          tank.sensorId = sensor.id
        }
        this.tankItem = tank
        this.records = record.records
      } catch (err) {
        this.tankItem = {}
        this.records = []
      } finally {
        this.tankChartLoader = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.details {
  position: fixed;
  right: calc(10% - 100px);
  bottom: calc(12% - 60px);
  z-index: 10;
  max-width: 400px;
  background: radial-gradient(var(--metal-blue), transparent);
}
.close-btn {
  top: -16px;
  right: -8px;
  background: radial-gradient(#0046af, transparent);
}
.flex {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.tank-box {
  height: 13.5rem;
}
.tank-info {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--metal-blue);
  color: var(--metal-white);
  padding: 3px 8px;
  border-radius: 3px;
}
.pagination {
  position: absolute;
  top: 4px;
  right: 12px;
  font-size: 0.8rem;
  color: #2a4c80;
}
.active{
  background: #b3d4fc;
}

.refuel-btn-container{
  padding-top: 25px!important;
  justify-content: flex-end;
}
//TankChart transition
.chart-enter-active {
  transition: transform 0.3s, opacity 0.3s ease-out;
}
.chart-leave-active {
  transition: transform 0.6s, opacity 0.2s ease-in;
}
.chart-enter, .chart-leave-to {
  transform: translateX(60px);
  opacity: 0;
}
</style>
